import { render, staticRenderFns } from "./Default-page.vue?vue&type=template&id=31419480&"
import script from "./Default-page.vue?vue&type=script&lang=js&"
export * from "./Default-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports